import { render, staticRenderFns } from "./ButtonSideBarMetrics.vue?vue&type=template&id=246f8a1c"
import script from "./ButtonSideBarMetrics.vue?vue&type=script&lang=js"
export * from "./ButtonSideBarMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports